<template>
  <v-container fluid class="py-0">
    <!--Dialog In order to Replace existing fasi with new ciclostd fasi or add as child -->
    <!-- Dialog to show list of fasi standard -->
    <v-dialog v-model="dailogciclostandardconfirm" width="50%">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Aggiunta / Sostituzione Cicli Standard
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                @click="dailogciclostandardconfirm = false"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="setAsChild" small>Aggiungi</v-btn>
          <v-btn color="warning" @click="setAsCicloNew" small>sostituire</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog to show list of fasi standard -->
    <v-dialog
      v-model="dialogciclistandard"
      width="75%"
      content-class="dialogshadow"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Cicli Standard</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                @click="dialogciclistandard = false"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="max-height: 600px; overflow-y: auto">
          <v-data-table :headers="cicloheaders" :items="cicloitems">
            <template v-slot:[`item.edit`]="{ item }">
              <v-col md="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      style="float: left"
                      @click="openconfimationCicloStd(item)"
                      small
                    >
                      <v-icon color="success">mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Aggiungi</span>
                </v-tooltip>
              </v-col>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog to show list of fasi Standard Table in Ciclo Commessa Produzione -->
    <v-dialog
      v-model="dialogfasestandard1"
      width="75%"
      content-class="dialogshadow"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Fasi Standard</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                @click="dialogfasestandard1 = false"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="max-height: 600px; overflow-y: auto">
          <v-data-table :headers="fasiHeaders" :items="fasiStdLista">
            <template v-slot:[`item.edit`]="{ item }">
              <v-col md="4">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-on="on"
                      v-bind="attrs"
                      style="float: left"
                      @click="addToCicli(item)"
                      small
                    >
                      <v-icon color="primary">mdi-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Aggiungi</span>
                </v-tooltip>
              </v-col>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Dialog to show list of fasi standard Table in Ciclo Commessa Produzione -->
    <v-dialog
      v-model="dialogfasestandard"
      width="75%"
      content-class="dialogshadow"
    >
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">Fasi Standard</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-btn small @click="showFasi">
            <v-icon color="success">mdi-floppy</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-on="on"
                v-bind="attrs"
                small
                @click="dialogfasestandard = false"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <v-data-table
            v-model="selected"
            fixed-header
            height="70vh"
            item-key="des_fase_standard"
            :headers="fasiHeaders"
            :items="fasiStdLista"
            :single-select="singleSelect"
            :options="{ itemsPerPage: -1 }"
            show-select
          >
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      content-class="artDialog"
      v-model="dialogCiclo"
      :scrollable="true"
      persistent
      width="1400"
    >
      <v-container fluid>
        <form>
          <v-row style="height: 100% !important">
            <v-card>
              <v-toolbar dense class="indigo darken-1" primary-title uppercase>
                <v-toolbar-title class="white--text">
                  Ciclo Commessa Produzione
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <Button
                  classe_bottone="mr-2"
                  colore_icona="primary"
                  idForm="COMMESSA_CICLO"
                  idOggetto="AGGIUNGI_FASE_STANDARD"
                  mdi_icona="mdi-shape-circle-plus"
                  testo_tooltip="Aggiungi fase standard"
                  v-on:buttonClick="
                    getFaseStd();
                    dialogfasestandard1 = true;
                  "
                />
                <Button
                  colore_icona="success"
                  idForm="COMMESSA_CICLO"
                  idOggetto="SALVA_FASE"
                  mdi_icona="mdi-floppy"
                  testo_tooltip="Salva Fase"
                  v-on:buttonClick="updateCicloFasi"
                />
                <v-spacer></v-spacer>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn small @click="closeDialog">
                      <v-icon depressed v-on="on" v-bind="attrs" color="error"
                        >mdi-window-close</v-icon
                      >
                    </v-btn>
                  </template>
                  <span>Cancellare</span>
                </v-tooltip>
              </v-toolbar>
              <v-card-text
                class=""
                style="max-height: 600px; overflow-y: auto; overflow-x: hidden"
              >
                <v-row>
                  <v-col cols="2">
                    <v-text-field
                      dense
                      hide-details
                      label="Cod. Fase"
                      v-model="cod_fase"
                      :min_input="0"
                      type_input="number"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-autocomplete
                      dense
                      hide-details
                      v-model="des1"
                      :items="produzione_list"
                      label="Tipo Produzione"
                      placeholder="Tipo Produzione"
                      item-text="des"
                      item-value="des"
                      required
                    >
                      <template #label>
                        <span class="">Tipo Produzione<strong>* </strong></span>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="2">
                    <v-switch
                      dense
                      hide-details
                      v-model="materia_prima"
                      label="Prelievo Comp."
                      style="margin-top: -0.3rem !important"
                      class="mt-n1 ml-10"
                      :false-value="0"
                      :true-value="1"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      dense
                      hide-details
                      label="Tempo Standard"
                      v-model="tempo_standard"
                      :min="0"
                      type="number"
                    />
                  </v-col>
                  <v-col cols="2">
                    <v-autocomplete
                      dense
                      hide-details
                      style="width: 190px !important"
                      v-model="um_tempo"
                      :items="unita_misura_lead_time"
                      label="UM Tempo"
                      item-text="des"
                      required
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      dense
                      hide-details
                      label="Peso / Q.tà Dettaglio"
                      v-model="peso"
                      :min="0"
                      type="number"
                    />
                  </v-col>
                </v-row>
                <v-row align="center" class="my-0" justify="start">
                  <v-col cols="2">
                    <v-autocomplete
                      dense
                      hide-details
                      style="width: 150px !important"
                      v-model="um_pezzo"
                      :items="unita_misura_peso"
                      label="UM Peso"
                      item-text="des"
                      required
                    >
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="2">
                    <v-autocomplete
                      dense
                      hide-details
                      v-model="des"
                      :items="fase_list"
                      label="Fase. Lavo"
                      placeholder="Fase. Lavo"
                      item-text="des"
                      required
                    >
                      <template #label>
                        <span class="">Fase. Lavo<strong>* </strong></span>
                        <a @click.stop style="pointer-events: all">
                          <Modules
                            @aggiornamento="aggiornaFase"
                            v-on:dialogModules="aggiornaFase"
                            tipo="FASE"
                            nome="Fase"
                            setaction="settabelle"
                            getaction="gettabelle"
                            controller="Magazzino"
                            filter="validita = 1"
                            :dati="[{ des: '' }]"
                          />
                        </a>
                      </template>
                    </v-autocomplete>
                  </v-col>
                  <v-col cols="2">
                    <v-switch
                      dense
                      hide-details
                      label="Fase Esterna"
                      v-model="fase_esterna"
                      style="margin-top: -0.3rem !important"
                      class="mt-n1 ml-10"
                      :false-value="0"
                      :true-value="1"
                    ></v-switch>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      dense
                      hide-details
                      label="PZ. Parall."
                      :min="0"
                      type="number"
                      v-model="pezzi_parallelismo"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      dense
                      hide-details
                      label="Perc. Parall."
                      :max="100"
                      :min="0"
                      type="number"
                      v-model="percentuale_parallelismo"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-menu
                      dense
                      v-model="menu4"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          :value="formatdataScadenza"
                          label="Data Scadenza"
                          prepend-icon="event"
                          readonly
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        style="width: 100% !important"
                        v-model="data_scadenza"
                        @input="menu4 = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row align="center" class="my-0" justify="start">
                  <v-col cols="2">
                    <v-icon
                      :color="
                        flag_segnalazione == null ||
                        flag_segnalazione == '' ||
                        flag_segnalazione == 0
                          ? ''
                          : 'success'
                      "
                      @click="switchFlagSegnalazione()"
                    >
                      {{
                        flag_segnalazione == null ||
                        flag_segnalazione == "" ||
                        flag_segnalazione == 0
                          ? "mdi-checkbox-blank-outline"
                          : "mdi-checkbox-marked"
                      }}
                    </v-icon>
                    Genera Segnalazione
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      dense
                      hide-details
                      label="Pezzi Setup"
                      type="number"
                      v-model="pezzi_setup"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-icon
                      :color="
                        multioperatore == null ||
                        multioperatore == '' ||
                        multioperatore == 0
                          ? ''
                          : 'success'
                      "
                      @click="switchFlagMultioperatore()"
                    >
                      {{
                        multioperatore == null ||
                        multioperatore == "" ||
                        multioperatore == 0
                          ? "mdi-checkbox-blank-outline"
                          : "mdi-checkbox-marked"
                      }}
                    </v-icon>
                    Multioperatore
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      dense
                      hide-details
                      label="Lead Time"
                      type="number"
                      v-model.number="lead_time"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field
                      v-model="ora_inizio_pianificata"
                      label="Ora Inizio Pianificata"
                      type="datetime-local"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    class="mt-n7"
                    v-show="fase_esterna == 1"
                  >
                    <Fornitura
                      FORM_ID="COMMESSA"
                      SOTTO_FORM="COMMESSA_CICLO"
                      :FORM_BUTTON_ARRAY="FORM_BUTTON_ARRAY"
                      v-on:updateFornitura="updateFornitura($event)"
                      :key="dialogCiclo"
                      :data="Fornitoridata"
                      v-on:delFornitura="deleteFornituraLista($event)"
                    />
                  </v-col>
                  <v-col cols="6" v-show="fase_esterna == 0">
                    <Macchina
                      FORM_ID="COMMESSA"
                      SOTTO_FORM="COMMESSA_CICLO"
                      :MACCHINA_BUTTON_ARRAY="MACCHINA_BUTTON_ARRAY"
                      v-on:updateMacchina="updateMacchina($event)"
                      :key="dialogCiclo"
                      :data="Macchinadata"
                      :id_commessa_dettaglio="id_commessa_dettaglio"
                      :commessa_form="commessa_form"
                      :commessa_data="cicloData"
                      v-on:delMacchina="delMacchina($event)"
                    />
                  </v-col>
                  <v-col cols="6" v-show="fase_esterna == 0">
                    <Personale
                      FORM_ID="COMMESSA"
                      SOTTO_FORM="COMMESSA_CICLO"
                      :PERSONALE_BUTTON_ARRAY="PERSONALE_BUTTON_ARRAY"
                      v-on:updatePersonale="updatePersonale($event)"
                      :key="id_temp"
                      :data="commessa_dettaglio_personale"
                      v-on:delPersonale="delPersonale($event)"
                    />
                  </v-col>
                </v-row>
                <v-row align="center" justify="start">
                  <v-col md="12">
                    <v-textarea
                      outlined
                      v-model="note"
                      item-text="text"
                      label="Annotazione"
                      placeholder="Annotazione"
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-row>
        </form>
      </v-container>
    </v-dialog>
    <form>
      <v-row>
        <v-col md="12">
          <v-hover>
            <template v-slot="{ hover }">
              <v-card :elevation="hover ? 24 : 2">
                <v-toolbar dense class="indigo darken-1" primary-title>
                  <v-toolbar-title class="white--text">
                    Ciclo Commessa Produzione
                  </v-toolbar-title>

                  <v-spacer></v-spacer>
                  <Button
                    classe_bottone="ml-2"
                    colore_icona="primary"
                    idForm="COMMESSA_CICLO"
                    idOggetto="RECUPERA_FASI"
                    mdi_icona="mdi-plus-circle-multiple-outline"
                    testo_tooltip="Recupera Fasi"
                    v-on:buttonClick="setFasiToIntialState"
                  />
                  <Button
                    classe_bottone="ml-2"
                    colore_icona="error"
                    idForm="COMMESSA_CICLO"
                    idOggetto="CANCELLA_FASI"
                    mdi_icona="mdi-close-circle-multiple"
                    testo_tooltip="Cancella Fasi"
                    v-on:buttonClick="delAllFasi"
                  />
                  <v-spacer></v-spacer>
                  <Button
                    colore_icona="primary"
                    idForm="COMMESSA_CICLO"
                    idOggetto="CREA_FASE"
                    mdi_icona="mdi-plus"
                    testo_tooltip="Nuova Fase"
                    v-on:buttonClick="opendialogciclo"
                  />
                  <Button
                    classe_bottone="ml-2"
                    colore_icona="primary"
                    idForm="COMMESSA_CICLO"
                    idOggetto="AGGIUNGI_CICLO_STANDARD"
                    mdi_icona="mdi-vector-circle-variant"
                    testo_tooltip="Aggiungi ciclo standard"
                    v-on:buttonClick="
                      getCicloStd();
                      dialogciclistandard = true;
                    "
                  />
                  <Button
                    classe_bottone="ml-2"
                    colore_icona="primary"
                    idForm="COMMESSA_CICLO"
                    idOggetto="AGGIUNGI_FASE_STANDARD"
                    mdi_icona=" mdi-shape-circle-plus "
                    testo_tooltip="Aggiungi fase standard"
                    v-on:buttonClick="
                      getFaseStd();
                      dialogfasestandard = true;
                    "
                  />
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table
                  :loading="loadingCiclo"
                  :headers="CicloHeaders"
                  :items="cicloLista"
                >
                  <v-progress-linear
                    v-show="progressBarCiclo"
                    slot="progress"
                    color="blue"
                    indeterminate
                  ></v-progress-linear>
                  <template v-slot:[`item.edit`]="{ item }">
                    <Button
                      colore_icona="primary"
                      idForm="COMMESSA_CICLO"
                      idOggetto="MODIFICA_FASE"
                      mdi_icona=" mdi-pencil"
                      testo_tooltip="Aggiornare"
                      v-on:buttonClick="handleClick(item)"
                    />
                  </template>

                  <!-- Colonna della ora_inizio_pianificata -->
                  <template v-slot:[`item.ora_inizio_pianificata`]="{ item }">
                    <v-text-field
                      background-color="white"
                      @change="aggiornaMacchinaPredefinita(item, 'ora')"
                      dense
                      hide-details
                      outlined
                      style="border-radius: 0px"
                      type="datetime-local"
                      v-model="item.ora_inizio_pianificata"
                    />
                  </template>

                  <!-- Colonna del bottone di Graph -->
                  <template v-slot:[`item.graph`]="{ item }">
                    <v-tooltip>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="apriGraphFromTable(item)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary"> mdi-chart-bar </v-icon>
                        </v-btn>
                      </template>
                      <span>Graph</span>
                    </v-tooltip>
                  </template>

                  <!-- Colonna della selezione della macchina -->
                  <template v-slot:[`item.id_macchina`]="{ item }">
                    <v-autocomplete
                      background-color="white"
                      :items="item.commessa_dettaglio_macchina"
                      item-text="des_macchina"
                      item-value="id_macchina"
                      @change="aggiornaMacchinaPredefinita(item, 'macchina')"
                      v-model="item.id_macchina"
                    ></v-autocomplete>
                  </template>

                  <template
                    v-slot:[`item.commessa_dettaglio_gruppo`]="{ item }"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="openGruppoFasi(item)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon
                            :color="
                              getColorGruppoFasi(item.commessa_dettaglio_gruppo)
                            "
                          >
                            mdi-source-branch
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Gruppo Fasi</span>
                    </v-tooltip>
                  </template>

                  <template v-slot:[`item.operazioni_fase`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="apriOperazioniDialog(item)"
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="primary">
                            mdi-format-list-numbered
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Operazioni Fase</span>
                    </v-tooltip>
                  </template>

                  <!-- Pulsante di gestione del ciclo autocontrollo -->
                  <template v-slot:[`item.ciclo_autocontrollo`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="apriCicloAutocontrollo(item)"
                          small
                          v-bind="attrs"
                          v-on="on"
                          :disabled="
                            item.id_ciclo_autocontrollo == -1 ||
                            item.id_ciclo_autocontrollo == null ||
                            item.id_ciclo_autocontrollo == undefined
                          "
                        >
                          <v-icon color="primary"> mdi-file-find </v-icon>
                        </v-btn>
                      </template>
                      <span>Apri ciclo autocontrollo</span>
                    </v-tooltip>
                  </template>

                  <template v-slot:[`item.quickcheck`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          :class="
                            cicloData.commessa[0].id_commessa == -1
                              ? 'elevation-0'
                              : ''
                          "
                          :color="
                            cicloData.commessa[0].id_commessa == -1
                              ? 'grey lighten-1'
                              : ''
                          "
                          @click="
                            cicloData.commessa[0].id_commessa == -1
                              ? null
                              : clickQuestionari(item)
                          "
                          small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon
                            :color="
                              cicloData.commessa[0].id_commessa == -1
                                ? 'grey darken-1'
                                : 'primary'
                            "
                            >mdi-help-network</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>{{
                        cicloData.commessa[0].id_commessa == -1
                          ? "Salvare la commessa prima di modificare"
                          : "Questionari"
                      }}</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.flag_segnalazione`]="{ item }">
                    <v-icon
                      :color="
                        item.flag_segnalazione == null ||
                        item.flag_segnalazione == '' ||
                        item.flag_segnalazione == 0
                          ? ''
                          : 'success'
                      "
                    >
                      {{
                        item.flag_segnalazione == null ||
                        item.flag_segnalazione == "" ||
                        item.flag_segnalazione == 0
                          ? "mdi-checkbox-blank-outline"
                          : "mdi-checkbox-marked"
                      }}
                    </v-icon>
                  </template>
                  <template v-slot:[`item.multioperatore`]="{ item }">
                    <v-icon
                      :color="
                        item.multioperatore == null ||
                        item.multioperatore == '' ||
                        item.multioperatore == 0
                          ? ''
                          : 'success'
                      "
                    >
                      {{
                        item.multioperatore == null ||
                        item.multioperatore == "" ||
                        item.multioperatore == 0
                          ? "mdi-checkbox-blank-outline"
                          : "mdi-checkbox-marked"
                      }}
                    </v-icon>
                  </template>
                  <template v-slot:[`item.prelievi`]="{ item }">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          @click="clickPrelieviCommessa(item)"
                          :disabled="
                            item.id_commessa == -1 ||
                            is_quantita_updated == true
                          "
                          v-bind="attrs"
                          v-if="item.materia_prima == 1"
                          v-on="on"
                        >
                          <v-icon
                            :color="flag_picking == 1 ? 'success' : 'primary'"
                            >mdi-archive-cog-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Impegni</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.materia_prima`]="{ item }">
                    <v-icon v-if="item.materia_prima == 1"
                      >mdi-check-underline</v-icon
                    >
                  </template>
                  <template v-slot:[`item.fase_esterna`]="{ item }">
                    <v-icon v-if="item.fase_esterna == 1"
                      >mdi-check-underline</v-icon
                    >
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <Button
                      colore_icona="error"
                      idForm="COMMESSA_CICLO"
                      idOggetto="ELIMINA_FASE"
                      mdi_icona=" mdi-window-close"
                      testo_tooltip="Cancellare"
                      v-on:buttonClick="clickDelCommessa(item)"
                    />
                  </template>
                </v-data-table>
              </v-card>
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </form>
    <v-snackbar
      content-class="snackbar"
      :color="snackbar_background"
      right
      v-model="snackbar"
      :timeout="3000"
    >
      <v-icon :color="snackbar_icon_color" :size="64">{{
        snackbar_icon
      }}</v-icon>
      <h2 :style="{ color: snackbar_text_color + '!important' }" class="ml-16">
        {{ snackbar_text }}
      </h2>
      <v-btn
        @click="snackbar = false"
        fab
        dark
        text
        small
        style="
          margin-top: -6rem;
          float: right !important;
          margin-right: -1rem !important;
        "
      >
        <v-icon :color="snackbar_icon_color">mdi-window-close</v-icon>
      </v-btn>
    </v-snackbar>

    <!-- Dialog di conferma del prelievo materia prima in commessa -->
    <v-dialog v-model="conferma_impegno_materia" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Gestione Materia Prima
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler gestire i prelievi di materia prima nella
            commessa?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_impegno_materia = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="prelieviCommessa" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog della gestione prelievi -->
    <v-dialog persistent v-model="prelievi_visible">
      <Prelievi
        @click_chiudi="prelievi_visible = !prelievi_visible"
        :fase_sel="work_order_sel"
        :quantita="cicloData.commessa[0]?.quantita"
        :qta_realizzabile_autonoma="true"
        :visibile="prelievi_visible"
        :modulo_chiamante="'COMMESSA'"
        @setqueryevent="handleSetQueryEvent"
      />
    </v-dialog>

    <!-- Dialog dei questionari associati alla fase -->
    <v-dialog v-model="questionari_fase_visible">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Questionari Associati
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di aggiunta -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="aggiungiQuestionario"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary">mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>

          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaQuestionariAssociati"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success">mdi-floppy</v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di eliminazione -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="questionari_fase_visible = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text style="overflow-y: auto">
          <v-data-table
            :headers="headers_questionari_associati"
            :items="items_questionari_associati.filter((q) => q.validita == 1)"
          >
            <!-- Bottone di eliminazione -->
            <template v-slot:[`item.eliminazione`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="clickEliminaQuestionarioAllegato(item)"
                    small
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon color="error"> mdi-close </v-icon>
                  </v-btn>
                </template>
                <span>Elimina</span>
              </v-tooltip>
            </template>

            <!-- Autocomplete del pulsante -->
            <template v-slot:[`item.pulsante`]="{ item }">
              <v-autocomplete
                dense
                hide-details
                item-text="text"
                item-value="value"
                :items="items_pulsanti_questionari"
                style="max-width: 200px"
                v-model="item.pulsante"
              >
              </v-autocomplete>
            </template>

            <!-- Autocomplete dell'obbligatorietà -->
            <template v-slot:[`item.obbligatorio`]="{ item }">
              <v-icon
                @click="switchObblogatorieta(item)"
                :color="
                  (item.obbligatorio == 0) == null ||
                  item.obbligatorio == 0 ||
                  item.obbligatorio == ''
                    ? ''
                    : 'primary'
                "
              >
                {{
                  (item.obbligatorio == 0) == null ||
                  item.obbligatorio == 0 ||
                  item.obbligatorio == ""
                    ? "mdi-checkbox-blank-outline"
                    : "mdi-checkbox-marked"
                }}
              </v-icon>
            </template>

            <!-- Colonna del multiplo -->
            <template v-slot:[`item.multiplo`]="{ item }">
              <v-icon
                @click="switchMultiplo(item)"
                :color="
                  item.multiplo == 0 ||
                  item.multiplo == 0 ||
                  item.multiplo == ''
                    ? ''
                    : 'primary'
                "
              >
                {{
                  item.multiplo == 0 ||
                  item.multiplo == 0 ||
                  item.multiplo == ""
                    ? "mdi-checkbox-blank-outline"
                    : "mdi-checkbox-marked"
                }}
              </v-icon>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei questionari associati -->
    <v-dialog v-model="conferma_eliminazione_questionario" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare l'associazione del questionario
            selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="conferma_eliminazione_questionario = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaQuestionarioAllegato" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei questionari associati -->
    <v-dialog v-model="dialog_conferma_eliminazione" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare la fase selezionata? <br />
            {{
              work_order_sel.commessa_dettaglio_gruppo == 1
                ? "(La fase è abbinante rispetto ad altre.)"
                : work_order_sel.commessa_dettaglio_gruppo == 2
                ? `(Questa fase risulta abbinata fase ${
                    info_abbinante_alert.cod_fase
                  } della commessa ${info_abbinante_alert.cod_commessa}${
                    info_abbinante_alert.riferimento == "" ||
                    info_abbinante_alert.riferimento == null
                      ? ""
                      : ", riferimento " + info_abbinante_alert.riferimento
                  }.)`
                : ""
            }}
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_eliminazione = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn
                  @click="
                    dialog_conferma_eliminazione = false;
                    delcommessa(work_order_sel);
                  "
                  small
                >
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog del componente dinamico Check -->
    <v-dialog class="ma-0 pa-0" v-model="check_dialog_visible">
      <v-card
        class="ma-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeCheck"
            :component="'check'"
            ref="windowframe_check"
            @questionario_selezionato="handleQuestionarioSelezionato"
            :input_args="input_args_check"
            @loaded="handleCheckLoaded()"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Dialog di aggiunta / modifica operazioni fase -->
    <v-dialog v-model="dialog_operazioni" width="90vw">
      <GestioneOperazioni
        :checkbox_suggerimento="true"
        @click_chiudi="chiudiOperazioni"
        :items_operazioni_fase="items_operazioni_fase"
        @salva_operazioni_fase="salvaOperazioniFase"
        v-if="dialog_operazioni"
      />
    </v-dialog>

    <!-- Dialog del ciclo di autocontrollo -->
    <v-dialog
      class="ma-0 pa-0"
      width="1200px"
      v-model="dialog_ciclo_autocontrollo"
      persistent
    >
      <v-card
        class="ma-0 pa-0"
        style="overflow: hidden"
        height="calc(100vh - 100px)"
      >
        <WindowFrame
          class="ma-0 pa-0"
          referrerpolicy="origin"
          ref="windowframe_quality"
          :component="'quality'"
          :input_args="input_args_ciclo_autocontrollo"
          :key="key_ciclo_autocontrollo"
          :route="route"
          @click_chiudi="handleClickChiudiQualita"
        />
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_gruppo_fasi" persistent width="80vh">
      <CommessaGruppoFasi
        @click_chiudi="closeGruppoFasi"
        :cod_commessa_padre_gruppo="cod_commessa_padre_gruppo"
        :cod_fase_padre_gruppo="cod_fase_padre_gruppo"
        :id_padre_gruppo_fasi="id_padre_gruppo_fasi"
        @salvataggio_eseguito="handleSalvataggioGruppoFasi"
        :visible="dialog_gruppo_fasi"
      />
    </v-dialog>

    <v-dialog v-model="graphDialog" width="80vw">
      <v-toolbar class="white--text" color="indigo" dense>
        <v-toolbar-title>Quick Graph</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mr-5"
              @click="graphDialog = false"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="error">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Chiudi</span>
        </v-tooltip>
      </v-toolbar>
      <v-card height="80vh" style="overflow-y: scroll">
        <WindowFrame
          component="graph"
          :input_args="graphArgs"
          :key="graphKey"
          @query_update="handleQueryUpdate"
        >
        </WindowFrame>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" style="z-index: 1">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <SnackbarQV ref="SnackbarQV" />
  </v-container>
</template>
<script>
import Button from "../../../components/TOOLS/FormComponentPermissions/Button.vue";
import CommessaGruppoFasi from "@/views/PRODUCTION/Commesa/CommessaGruppoFasi.vue";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
// import TextField from "../../../components/TOOLS/FormComponentPermissions/TextField";
import moment from "moment";
import Fornitura from "../Common/Fornitura.vue";
import GestioneOperazioni from "@/views/PRODUCTION/Commesa/GestioneOperazioni.vue";
import Macchina from "../Common/Macchina.vue";
import Personale from "../Common/Personale.vue";
import Prelievi from "@/components/PRODUCTION/Produzione/Prelievi.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  props: [
    "cicloData",
    "IdArticolo",
    "is_quantita_updated",
    "items_tipi_pianificazione",
  ],
  components: {
    Modules: () => import("../../../components/TOOLS/Modules"),
    Button,
    CommessaGruppoFasi,
    GestioneOperazioni,
    // TextField,
    Macchina,
    Fornitura,
    Personale,
    Prelievi,
    SnackbarQV,
    WindowFrame,
  },
  data() {
    return {
      //<==============================Ciclo Variables=====================>//
      FORM_BUTTON_ARRAY: [
        "CREA_COMMESSA_FASE_FORNITURA",
        "MODIFICA_COMMESSA_FASE_FORNITURA",
        "ELIMINA_COMMESSA_FASE_FORNITURA",
        "SALVA_COMMESSA_FASE_FORNITURA",
      ],
      MACCHINA_BUTTON_ARRAY: [
        "CREA_COMMESSA_FASE_MACCHINA",
        "MODIFICA_COMMESSA_FASE_MACCHINA",
        "ELIMINA_COMMESSA_FASE_MACCHINA",
        "SALVA_COMMESSA_FASE_MACCHINA",
      ],
      PERSONALE_BUTTON_ARRAY: [
        "CREA_COMMESSA_FASE_PERSONALE",
        "MODIFICA_COMMESSA_FASE_PERSONALE",
        "ELIMINA_COMMESSA_FASE_PERSONALE",
        "SALVA_COMMESSA_FASE_PERSONALE",
      ],
      items_pulsanti_questionari: new Array(),

      // Stati
      cod_commessa_padre_gruppo: null,
      cod_fase_padre_gruppo: null,
      graphArgs: {
        evento_target: "load_dashboard",
        payload: {
          show_overall: false,
          version: 0,
          dashboard: -1,
          params: [],
        },
      },
      graphKey: true,
      id_padre_gruppo_fasi: null,
      id_stato_creata: null,
      id_stato_aperta: null,
      id_stato_chiusa: null,
      id_stato_sospesa: null,
      id_stato_annullata: null,
      // data_scadenza var
      commessa_form: true,
      data_scadenza: "",
      ora_inizio_pianificata: "",
      descrizione_search: "",
      info_abbinante_alert: new Object(),
      menu4: false,
      temp_array: [],
      cicloLista1: [],
      cicloLista: [],
      fase_lavorazione_list: [],
      progressBarCiclo: false,
      lead_time: null,
      loadingCiclo: false,
      dialogCiclo: false,
      dialog_conferma_eliminazione: false,
      conferma_impegno_materia: false,
      id_ciclo_fasi: "",
      cod_fase: "",
      percentuale_parallelismo: 0,
      pezzi_setup: 0,
      pezzi_parallelismo: 0,
      produzione_list: [],
      id_tipo_fase: "",
      flag_picking: 0,
      flag_segnalazione: 0,
      multioperatore: 0,
      id_fase: "",
      fase_list: [],
      search: "",
      peso: "",
      unita_misura_peso: [],
      des: "",
      des1: "",
      cod_macchina: null,
      costo_lavorazione: null,
      fase_esterna: 0,
      materia_prima: 0,
      tempo_standard: 0,
      id_um_tempo: "",
      des_um_tempo: "",
      id_um_pezzo: "",
      um_pezzo: "",
      singleitem: {},
      unita_misura_lead_time: [],
      note: "",
      prelievi_visible: false,
      work_order_sel: {},
      landing_page_check: "dashboard",
      input_args_check: {
        toolbar_visible: localStorage.id_profilo == 1 ? true : false,
        toolbar_btn_autorizzazioni: true,
        toolbar_btn_chiudi: localStorage.id_profilo == 1 ? true : false,
        toolbar_btn_esecuzione: false,
        toolbar_btn_progettazione: true,
        toolbar_btn_risultati: false,
      },
      input_args_ciclo_autocontrollo: {},
      input_args_modules: {
        tipo: "OPERAZIONE_FASE_COMMESSA",
        showScadenza: false,
        nome: "Operazioni Fase",
        filter: "",
        landing_page: "/modules",
        nome_col: "Descrizione",
      },
      key_ciclo_autocontrollo: 0,

      // Variable for pop modal for deletion
      dialog_gruppo_fasi: false,
      dialogdeletecicloconfirmation: false,
      selectedCiclo: {},
      //<======== Fornitura Variables =====>//
      id_commessa_dettaglio: -1,
      ID_COMMESSA: -1,
      Fornitoridata: [],
      commessa_dettaglio_fornitori: [],
      fornitoriLista: [],
      deletedFornitura: [],
      // Macchina Variables
      commessa_dettaglio_macchina: [],
      macchina_predefinito: false,
      articolo_ciclo_fasi_macchina: [],
      singleMacchina: {},
      deletedMacchina: [],
      Macchinadata: [],
      items_questionari_associati: new Array(),
      // Personale Variables
      commessa_dettaglio_personale: [],
      deletedPersonale: [],
      // Variabili d'appoggio
      conferma_eliminazione_questionario: false,
      id_questionario_sel: null,
      index_sel: null,
      //  <=======================Generic Variables =====================>
      // cicloheaders
      cicloheaders: [],
      cicloitems: [],
      dialogciclistandard: false,
      dialog_ciclo_autocontrollo: false,
      dailogciclostandardconfirm: false,
      dialog_operazioni: false,
      graphDialog: false,
      selectedCicloStd: {},
      singleSelect: false,
      selected: [],
      dialogfasestandard: false,
      dialogfasestandard1: false,
      item: "",
      route: "",
      overlay: false,
      id_articolo: this.IdArticolo,
      validita: 1,
      id_fase_sel: null,
      check_dialog_visible: false,
      questionari_fase_visible: false,
      // Confirmation Dialog
      dialogSavingConfirmation: false,
      // Snackbar Variables
      snackbar: false,
      snackbar_background: "",
      snackbar_icon: "",
      snackbar_icon_color: "",
      snackbar_text: "",
      snackbar_text_color: "",
      color: "",
      id_temp: "",
      um_tempo: "",
      id_temp_dett: "",
      // Fasi Standard List and Fasi standard Headers
      fasiStdLista: [],
      fasiHeaders: [],
      // Header of ciclo table
      CicloHeaders: [
        {
          value: "edit",
        },
        {
          text: "Operazioni Fase",
          value: "operazioni_fase",
          sortable: false,
        },
        {
          text: "Ciclo Autocontrollo",
          value: "ciclo_autocontrollo",
          sortable: false,
        },
        {
          text: "Questionari",
          value: "quickcheck",
          sortable: false,
        },
        {
          text: "Genera Segnalazione",
          value: "flag_segnalazione",
          sortable: false,
        },
        {
          text: "Multioperatore",
          value: "multioperatore",
          sortable: false,
        },
        {
          value: "prelievi",
        },
        {
          text: "Cod. Fase",
          value: "cod_fase",
          sortable: false,
        },
        {
          text: "Tipo Fase",
          value: "des1",
          sortable: false,
        },
        {
          text: "Prelievo Comp",
          value: "materia_prima",
          sortable: false,
        },
        {
          text: "Lavoro Esterna",
          value: "fase_esterna",
          sortable: false,
        },
        {
          text: "Fase Lavoro",
          value: "des",
          sortable: false,
        },
        {
          text: "Peso / Q.tà Dettaglio",
          value: "peso",
          sortable: false,
        },
        {
          text: "Lotto Prod",
          value: "lotto_produzione",
          sortable: false,
        },
        {
          text: "Data Scadenza",
          value: "data_scadenza",
          sortable: false,
        },
        {
          text: "Ragione Sociale",
          value: "ragione_sociale",
          sortable: false,
        },
        {
          text: "Trasf. Diretto",
          value: "trasf_diretto",
          sortable: false,
        },
        {
          text: "Lead Time",
          value: "lead_time",
          sortable: false,
        },
        {
          text: "Lotto Lavoro",
          value: "lotto_lavorazione",
          sortable: false,
        },
        {
          text: "Costo Lavoro",
          value: "costo_lavorazione",
          sortable: false,
        },
        {
          text: "Tempo Standard",
          value: "tempo_standard",
          sortable: false,
        },
        {
          text: "Pezzi/h Min",
          value: "pezzi_ora_min",
          sortable: false,
        },
        {
          text: "Pezzi/h Max",
          value: "pezzi_ora_max",
          sortable: false,
        },
        {
          text: "Macchina",
          value: "codice",
          sortable: false,
        },
        {
          text: "Tempo Setup",
          value: "tempo_setup",
          sortable: false,
        },
        {
          text: "Attrezzatura",
          value: "id_attrezzatura",
          sortable: false,
        },
        {
          text: "Perc. Parall.",
          value: "percentuale_parallelismo",
          sortable: false,
        },
        {
          text: "Pz. Parall.",
          value: "pezzi_parallelismo",
          sortable: false,
        },
        {
          value: "actions",
          sortable: false,
        },
      ],
      headers_questionari_associati: [
        {
          text: "Titolo",
          value: "titolo_questionario",
          sortable: false,
        },
        {
          text: "Descrizione",
          value: "des_questionario",
          sortable: false,
        },
        {
          text: "Tipo",
          value: "des_tipo",
          sortable: false,
        },
        {
          text: "Pulsante",
          value: "pulsante",
          sortable: false,
          width: "200px",
        },
        {
          text: "Obbligatorio",
          value: "obbligatorio",
          sortable: false,
          width: "150px",
        },
        {
          text: "Completamento Multiplo",
          value: "multiplo",
          sortable: false,
          width: "150px",
        },
        {
          text: "Eliminazione",
          value: "eliminazione",
          sortable: false,
          width: "150px",
        },
      ],
      items_operazioni_fase: new Array(),
    };
  },
  methods: {
    aggiornaMacchinaDB(arg) {
      const macchine_tmp = Array();
      arg.commessa_dettaglio_macchina.forEach((m) => {
        macchine_tmp.push({
          idciclo_fasi_macchina: m.idciclo_fasi_macchina,
          predefinito: m.predefinito,
        });
      });

      /* Ogni tanto il formato dell'ora cambia misteriosamente: 
       * valuto se sia il caso di integrare i secondi o meno. */
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "updatemacchinacommessadettaglio",
          token: localStorage.user_token,
          id_commessa_dettaglio: arg.id_commessa_dettaglio,
          id_tipo_pianificazione: arg.id_tipo_pianificazione,
          ora_inizio_pianificata:
            arg.ora_inizio_pianificata != null &&
            arg.ora_inizio_pianificata !== ""
              ? `'${
                  arg.ora_inizio_pianificata.split(":").length == 3
                    ? arg.ora_inizio_pianificata
                    : arg.ora_inizio_pianificata + ":00"
                }'`.replace("T", " ")
              : "NULL",
          id_macchina:
            arg.commessa_dettaglio_macchina.filter((e) => e.predefinito == 1)
              .length > 0
              ? arg.commessa_dettaglio_macchina.filter(
                  (e) => e.predefinito == 1
                )[0].id_macchina
              : "",
          macchine: macchine_tmp,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
              "success",
              "I dati della fase sono stati aggiornati."
            );
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    aggiornaMacchinaPredefinita(arg, arg_input_modificato) {
      /* Valuto se è da aggiornare il tipo di pianificazione.
       * (Se l'utente ha modificato l'ora inizio pianificata, aggiorno.)*/
      if (
        arg_input_modificato == "ora" &&
        this.items_tipi_pianificazione &&
        this.items_tipi_pianificazione.length > 0
      ) {
        arg.id_tipo_pianificazione = this.items_tipi_pianificazione.filter(
          (p) => p.val_int == 1
        )[0]?.id_tabella;
      }

      // Aggiorno in FE il parametro predefinito delle macchine.
      arg.commessa_dettaglio_macchina.forEach((m) => {
        if (m.id_macchina == arg.id_macchina && m.validita == 1) {
          this.$set(m, "predefinito", 1);
        } else {
          this.$set(m, "predefinito", 0);
        }
      });

      // Se fra i miei header non ho Graph, non mi interessa andare avanti.
      if (this.CicloHeaders.filter((h) => h.value == "graph").length == 0) {
        return;
      }

      /* Se ho delle macchine con id di relazione a -1,
       * avviso di aggiornare per aprire Graph. */
      if (
        arg.commessa_dettaglio_macchina.filter(
          (m) => m.idciclo_fasi_macchina == -1
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "È necessario salvare la commessa per salvare le modifiche eseguite."
        );
        return;
      }

      /* Se ho tutte le informazioni registrate stabilmente,
       * procedo a mandare una chiamata automatica per allineare
       * i dati del DB come chiesto da Alberto il 28/08/2025. */
      if (
        arg.id_commessa_dettaglio > 0 &&
        arg.commessa_dettaglio_macchina.filter(
          (m) => m.idciclo_fasi_macchina == -1
        ).length == 0
      ) {
        this.aggiornaMacchinaDB(arg);
      }
    },
    apriGraphFromTable(arg) {
      // Se la commessa è nuova, prima devo salvarla.
      if (this.cicloData.commessa[0].id_commessa == -1) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Salvare la commessa prima di accedere a QuickGraph."
        );
        return;
      }

      /* Se la commessa è salvata ma ci sono fasi nuove, prima
       * di aprire Graph devo salvarle perché da lì si possono
       * attivare funzioni di pianificazione e se le fasi non
       * sono tutte registrate a DB escono fuori paciocchi. */
      if (this.computed_nuove_fasi_presenti) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Le fasi sono state modificate: salvare la commessa prima di accedere alla pianificazione."
        );
        return;
      }

      let request = {
        controller: "graph",
        method: "POST",
        richiesta: {
          action: "getassociazioni",
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api6", request).then((res) => {
        const dashInfo = res.data.result.filter((e) => e.cod == "COMMESSA")[0];
        this.graphArgs.payload.dashboard = dashInfo.id_dashboard;
        this.graphArgs.payload.params = [];
        if (
          typeof dashInfo.parametri != "undefined" &&
          dashInfo.parametri != null
        ) {
          for (const p of dashInfo.parametri.split(",")) {
            const p2 = p.replaceAll("$", "").trim();
            if (typeof arg[p2] != "undefined" && arg[p2] != null) {
              this.graphArgs.payload.params.push({
                simbolo: "$" + p2,
                valore: arg[p2].toString(),
              });
            }
          }
        }
        this.graphKey = !this.graphKey;
        this.graphDialog = true;
      });
    },
    aggiungiQuestionario() {
      this.check_dialog_visible = true;
    },
    apriCicloAutocontrollo(arg) {
      this.route = "";
      this.input_args_ciclo_autocontrollo.id_ciclo_autocontrollo =
        arg.id_ciclo_autocontrollo;
      this.dialog_ciclo_autocontrollo = true;
      this.key_ciclo_autocontrollo = this.key_ciclo_autocontrollo == 0 ? 1 : 0;
    },
    apriOperazioniDialog(arg) {
      this.singleItem = JSON.parse(JSON.stringify(arg));
      if (!this.singleItem.operazioni) {
        this.items_operazioni_fase = new Array();
      } else {
        this.items_operazioni_fase = JSON.parse(
          JSON.stringify(this.singleItem.operazioni)
        );
      }
      this.dialog_operazioni = true;
    },
    chiudiOperazioni() {
      this.dialog_operazioni = false;
    },
    clickDelCommessa(arg) {
      this.work_order_sel = JSON.parse(JSON.stringify(arg));
      if (arg.commessa_dettaglio_gruppo == 2) {
        const request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getgruppofasi",
            token: localStorage.user_token,
            id_commessa_dettaglio: arg.id_commessa_dettaglio,
            modalita: "search_abbinante",
          },
        };

        this.overlay = true;
        this.$store
          .dispatch("api", request)
          .then((res) => {
            this.overlay = false;
            if (res.status === 200) {
              this.info_abbinante_alert.cod_fase =
                res.data.result.gruppo[0].cod_fase;
              this.info_abbinante_alert.cod_commessa =
                res.data.result.gruppo[0].cod_commessa;
              this.info_abbinante_alert.riferimento =
                res.data.result.gruppo[0].riferimento;
              this.dialog_conferma_eliminazione = true;
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore di comunicazione col server, non  stato possibile salvare i dati."
              );
            }
          })
          .catch((err) => {
            this.overlay = false;
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          });
      } else {
        this.dialog_conferma_eliminazione = true;
      }
    },
    closeCheck() {
      this.check_dialog_visible = false;
    },
    closeGruppoFasi() {
      this.dialog_gruppo_fasi = false;
    },
    async clickQuestionari(arg) {
      // Registro la fase che è stata cliccata.
      this.id_fase_sel = arg.id_fase;

      /* Resetto e ripopolo la finestra di dialogo
       * dei questionari associati alla fase selezionata. */
      this.items_questionari_associati = new Array();
      this.items_questionari_associati = Array.from(arg.t_moduli_relazioni);

      // Apro la finestra di dialogo.
      this.questionari_fase_visible = true;
    },
    clickEliminaQuestionarioAllegato(arg) {
      this.id_questionario_sel = arg.id_relazione;
      this.conferma_eliminazione_questionario = true;
    },
    eliminaQuestionarioAllegato() {
      this.items_questionari_associati.forEach((q) => {
        if (q.id_relazione === this.id_questionario_sel) {
          q.validita = 0;
        }
      });

      this.conferma_eliminazione_questionario = false;
    },
    // populating deletedPersonale array if there is any element
    delPersonale(val) {
      this.deletedPersonale = val;
    },
    getColorGruppoFasi(arg) {
      return arg == 1 ? "success" : arg == 2 ? "orange" : "primary";
    },
    getHeaderCommessaDettaglio() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getheaderdettagliocommessa",
          token: localStorage.user_token,
          filtri: [],
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.overlay = false;
            if (res.data.t_header.length > 0) {
              this.CicloHeaders = new Array();
              res.data.t_header
                .filter((h) => h.visible == 1)
                .forEach((h) => {
                  this.CicloHeaders.push({
                    text: h.text,
                    value: h.value,
                    sortable: h.value == "des" ? true : false,
                    width:
                      h.value == "edit" ||
                      h.value == "actions" ||
                      h.value == "operazioni_fase" ||
                      h.value == "ciclo_autocontrollo" ||
                      h.value == "quickcheck" ||
                      h.value == "flag_segnalazione" ||
                      h.value == "multioperatore" ||
                      h.value == "ora_inizio_pianificata" ||
                      h.value == "commessa_dettaglio_gruppo"
                        ? "100px"
                        : "",
                  });
                });
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    handleCheckLoaded() {
      this.$refs.windowframe_check.postEvent("setparams", {
        landing_page: this.landing_page_check,
      });
    },
    handleClickChiudiQualita() {
      this.dialog_ciclo_autocontrollo = false;
    },
    handleQueryUpdate() {
      /* Graph mi ha detto che ha eseguito una query di update, che significa
       * che probabilmente dei dati del mio ciclo produzione sono cambiati:
       * quindi devo dire alla testata della commessa di ricaricarsi. */
      this.$emit("reload_commessa");
    },
    handleSalvataggioGruppoFasi() {
      this.dialog_gruppo_fasi = false;
      this.cicloLista.filter(
        (c) => c.id_commessa_dettaglio == this.id_padre_gruppo_fasi
      )[0].commessa_dettaglio_gruppo = 1;
      this.$refs.SnackbarQV.print(
        "success",
        "Il gruppo fasi è stato registrato."
      );
    },
    handleSetQueryEvent() {
      this.$emit("setqueryevent");
      this.prelievi_visible = false;
    },
    handleQuestionarioSelezionato(arg) {
      const obj_tmp = {
        id_relazione: -moment().valueOf(),
        id_riferimento: this.id_fase_sel,
        id_modulo: arg.id_questionario,
        riferimento: "commessa_dettaglio",
        pk_riferimento: "id_commessa_dettaglio",
        modulo: "questionario",
        titolo_questionario: arg.titolo_questionario,
        des_questionario: arg.des_questionario,
        pulsante: null,
        obbligatorio: 0,
        multiplo: 0,
        des_tipo: arg.des,
        pk_modulo: "id_questionario",
        validita: 1,
      };

      this.items_questionari_associati.push(obj_tmp);
      this.check_dialog_visible = false;
    },
    // Getting the Personale list to store on BE
    updatePersonale(val) {
      this.commessa_dettaglio_personale = val;
    },
    // populating deletedmacchina array if there is any element
    delMacchina(val) {
      this.deletedMacchina = val;
    },
    // Getting the macchina list to store on BE
    updateMacchina(val) {
      this.commessa_dettaglio_macchina = val;
    },
    //   Delete Fornitura populating
    deleteFornituraLista(val) {
      this.deletedFornitura = val;
    },
    // Getting updated Fornitura Lista
    updateFornitura(val) {
      this.commessa_dettaglio_fornitori = val;
    },
    // Open Ciclo Std Confirmation Dialog
    openconfimationCicloStd(item) {
      this.dailogciclostandardconfirm = true;
      this.selectedCicloStd = item;
    },
    setAsChild() {
      let getCicloStd = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getciclostd",
          token: localStorage.getItem("user_token"),
          id_ciclostd: this.selectedCicloStd.id_ciclostd,
          id_articolo: "",
          tipo_import: "",
        },
      };
      this.$store.dispatch("api", getCicloStd).then(async (res) => {
        let data = res.data.ciclostd[0].ciclostd_dettaglio;
        this.selected = data;
        this.showFasi();
        this.cicloData.commessa_dettaglio = this.cicloLista;
        this.dailogciclostandardconfirm = false;
        this.dialogciclistandard = false;
      });
    },
    // To set Ciclo Std as New ciclo or replace with existing ciclo
    setAsCicloNew() {
      if (this.cicloLista.filter((elem) => elem.validita == 1).length === 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci sono fasi da sostituire."
        );
        return;
      }

      this.delAllFasi();
      let getCicloStd = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getciclostd",
          token: localStorage.getItem("user_token"),
          id_ciclostd: this.selectedCicloStd.id_ciclostd,
          id_articolo: "",
          tipo_import: "",
        },
      };
      this.$store.dispatch("api", getCicloStd).then((res) => {
        this.selected = res.data.ciclostd[0].ciclostd_dettaglio;
        this.showFasi();
        this.cicloData.commessa_dettaglio = this.cicloLista;
        this.dailogciclostandardconfirm = false;
        this.dialogciclistandard = false;
      });
    },
    // Show All Ciclo Standard
    getCicloStd() {
      let getCicolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getciclostd",
          token: localStorage.getItem("user_token"),
          id_ciclostd: "",
          id_articolo: "",
          tipo_import: "",
        },
      };
      this.$store.dispatch("api", getCicolo).then((res) => {
        const data = res.data.lista;
        this.cicloheaders = res.data.header;
        let data2 = {
          value: "edit",
          sortable: false,
        };
        this.cicloheaders.unshift(data2);
        let data1 = {
          value: "delete",
          sortable: false,
        };
        this.cicloheaders.push(data1);
        this.cicloitems = data;
        this.overlay = false;
        this.dialogciclistandard = true;
      });
    },
    segnalaAggiornamentoCiclo() {
      // Se non ci sono gli headers che mi interessano mi fermo.
      if (
        this.CicloHeaders.filter(
          (elem) => elem.value == "ora_inizio_pianificata"
        ).length == 0
      ) {
        return;
      }

      /* Se invece ci sono gli header delle operazioni standard (quindi se
       * sono su Ferrara Quarzi) invio un evento che causa il salvataggio automatico
       * della commessa, perché l'utente non vuole perdere il tempo di un click
       * sul pulsante di salva e continua per vedere le operazioni legate alle
       * fasi appena aggiunte. */
      let evento = new CustomEvent("aggiornato_ciclo", {
        detail: {
          numero: null,
        },
        src: null,
      });

      document
        .getElementById("listener_commessa_dashboard")
        .dispatchEvent(evento);
    },
    // To set the cicloLista to initial stage
    setFasiToIntialState() {
      if (this.cicloLista.length > 0) {
        this.snackbar = true;
        this.snackbar_background = "orange";
        this.snackbar_color = "error";
        this.snackbar_icon = "mdi-window-close";
        this.snackbar_text =
          "è necessario attuare Cancella Fasi prima del Recupera Fasi";
        return;
        // alert("You must perfrom Cancella Fasi before Recupera Fasi")
      }
      // if (this.$route.params.id == -1) {
      let Getnewcommesa = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getnewcommessa",
          token: localStorage.getItem("user_token"),
          id_articolo: this.cicloData.commessa[0].id_articolo,
        },
      };
      this.$store.dispatch("api", Getnewcommesa).then((res) => {
        this.cicloLista = res.data.commessa_dettaglio;
        this.cicloData.commessa_dettaglio = this.cicloLista;
        this.cicloLista.sort(
          (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
        );
      });
      // }
      // if (this.$route.params.id >= 1) {
      // 	let getcommessa = {
      // 		controller: 'Magazzino',
      // 		method: 'POST',
      // 		richiesta: {
      // 			action: 'getcommessafull',
      // 			token: localStorage.getItem('user_token'),
      // 			id_commessa: this.$route.params.id,
      // 			id_profilo: localStorage.id_profilo,
      // 		},
      // 	};
      // 	this.$store.dispatch('api', getcommessa).then((res) => {
      // 		this.cicloLista = res.data.commessa_dettaglio;
      // 		this.cicloLista.sort((a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase));
      // 	});
      // }
    },
    // showFasi
    delAllFasi() {
      let deletedCicolo = [];
      this.cicloLista.forEach((item) => {
        item.validita = 0;
        deletedCicolo.push(item);
      });

      this.cicloLista = new Array();
      this.$emit("deletedCiclo", deletedCicolo);
    },
    showFasi() {
      let iterazioni_eseguite = 0;
      const selected_tmp = JSON.parse(JSON.stringify(this.selected));
      selected_tmp.map((it, idx) => {
        let getArticoloStandardDettaglioFromFaseStandard = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getfasestd",
            token: localStorage.getItem("user_token"),
            id_ciclostd_dettaglio: it.id_ciclostd_dettaglio,
            id_articolo: this.id_articolo,
            tipo_import: "C",
          },
        };

        this.overlay = true;
        this.$store
          .dispatch("api", getArticoloStandardDettaglioFromFaseStandard)
          .then((res) => {
            this.overlay = false;
            const fase_std_tmp = res.data.commessa_dettaglio[0];

            // Controllo che gli id_temp siano corretti.
            fase_std_tmp.id_temp = idx + 1;

            if (fase_std_tmp.commessa_dettaglio_personale)
              fase_std_tmp.commessa_dettaglio_personale.forEach((p) => {
                p.id_temp = idx + 1;
              });
            if (fase_std_tmp.commessa_dettaglio_macchina)
              fase_std_tmp.commessa_dettaglio_macchina.forEach((m) => {
                m.id_temp = idx + 1;
              });
            if (fase_std_tmp.commessa_dettaglio_fornitori)
              fase_std_tmp.commessa_dettaglio_fornitori.forEach((f) => {
                f.id_temp = idx + 1;
              });
            if (fase_std_tmp.operazioni)
              fase_std_tmp.operazioni.forEach((o) => {
                o.id_temp = idx + 1;
              });

            fase_std_tmp.operazioni.forEach((o) => {
              o.id_commessa_dettaglio =
                this.cicloData.commessa[0].id_commessa > -1
                  ? this.cicloData.commessa[0].id_commessa
                  : -1;
              o.id_commessa_operazione = -1;
            });
            const i = this.cicloLista.find(
              (it) => it.cod_fase == fase_std_tmp.cod_fase
            );

            if (i) {
              fase_std_tmp.cod_fase++;
              let last_item = this.cicloLista[this.cicloLista.length - 1];
              let last_cod_fase = last_item.cod_fase;
              if (this.cicloData.commessa[0].id_commessa > -1) {
                fase_std_tmp.id_commessa =
                  this.cicloData.commessa[0].id_commessa;
              } else {
                fase_std_tmp.id_commessa = -1;
              }
              fase_std_tmp.cod_fase = last_cod_fase += 10;
              this.cicloLista.push(fase_std_tmp);
              this.cicloLista.sort(
                (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
              );
              iterazioni_eseguite++;
            } else {
              if (this.cicloData.commessa[0].id_commessa > -1) {
                fase_std_tmp.id_commessa =
                  this.cicloData.commessa[0].id_commessa;
              } else {
                fase_std_tmp.id_commessa = -1;
              }
              this.cicloLista.push(fase_std_tmp);
              this.cicloLista.sort(
                (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
              );
              iterazioni_eseguite++;
            }

            // Se sono all'ultima iterazione...
            if (iterazioni_eseguite == selected_tmp.length) {
              this.cicloLista &&
                this.cicloLista.sort(
                  (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
                );

              /* Segnalo al componente padre che è avvenuto l'aggiornamento
               * del ciclo per soddisfare una richiesta di Ferrara Quarzi. */
              this.segnalaAggiornamentoCiclo();
            }
          })
          .catch((err) => {
            this.overlay = false;
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
            return false;
          });
      });

      this.dialogfasestandard = false;
      this.selected = [];
    },
    // In order to get Fasi Standard
    getFaseStd() {
      let getCicolo = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getfasestd",
          token: localStorage.getItem("user_token"),
          id_ciclostd_dettaglio: "",
        },
      };
      this.$store.dispatch("api", getCicolo).then((res) => {
        const data = res.data.lista;
        this.fasiHeaders = res.data.header;
        let data2 = {
          value: "edit",
          sortable: false,
        };
        this.fasiHeaders.unshift(data2);
        let data1 = {
          value: "delete",
          sortable: false,
        };
        this.fasiHeaders.push(data1);
        data.sort((a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase));
        this.fasiStdLista = data;
        if (this.cicloLista.length > 0) {
          this.progressBarCiclo = false;
          this.loadingCiclo = false;
        }
        if (this.cicloLista.length === 0) {
          this.progressBarCiclo = false;
          this.loadingCiclo = false;
        }
      });
    },
    openGruppoFasi(arg) {
      /* commessa_dettaglio_gruppo 1 -> abbinante
         commessa_dettaglio_gruppo 2 -> abbinato
         commessa_dettaglio_gruppo 3 -> libero
      */

      if (
        arg.commessa_dettaglio_gruppo == null ||
        arg.commessa_dettaglio_gruppo == ""
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Salvare la commessa prima di raggruppare le fasi."
        );
        return;
      }

      /* Se è già abbinato, non apro la finestra di dialogo
       * e cerco le informazioni sulla commessa abbinante. */
      if (arg.commessa_dettaglio_gruppo == 2) {
        const request = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getgruppofasi",
            token: localStorage.user_token,
            id_commessa_dettaglio: arg.id_commessa_dettaglio,
            modalita: "search_abbinante",
          },
        };

        this.overlay = true;
        this.$store
          .dispatch("api", request)
          .then((res) => {
            this.overlay = false;
            if (res.status === 200) {
              this.$refs.SnackbarQV.print(
                "orange",
                `Questa fase è subordinata alla fase ${
                  res.data.result.gruppo[0].cod_fase
                } della commessa ${res.data.result.gruppo[0].cod_commessa}${
                  res.data.result.gruppo[0].riferimento == "" ||
                  res.data.result.gruppo[0].riferimento == null
                    ? ""
                    : " (riferimento " +
                      res.data.result.gruppo[0].riferimento +
                      ")"
                }.`
              );
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                "Errore di comunicazione col server, non  stato possibile salvare i dati."
              );
            }
          })
          .catch((err) => {
            this.overlay = false;
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          });
      } else {
        this.id_padre_gruppo_fasi = arg.id_commessa_dettaglio;
        this.cod_commessa_padre_gruppo =
          this.cicloData.commessa[0].cod_commessa;
        this.cod_fase_padre_gruppo = arg.cod_fase;
        this.dialog_gruppo_fasi = true;
      }
    },
    // In order to Add Fase Standard into Ciclo table
    addToCicli(item) {
      if (this.dialogCiclo === true) {
        this.overlay = true;
        let getFaseStandardDettaglio = {
          controller: "Magazzino",
          method: "POST",
          richiesta: {
            action: "getfasestd",
            token: localStorage.getItem("user_token"),
            id_ciclostd_dettaglio: item.id_ciclostd_dettaglio,
            id_articolo: this.id_articolo,
            tipo_import: "C",
          },
        };
        this.$store
          .dispatch("api", getFaseStandardDettaglio)
          .then((res) => {
            this.overlay = false;
            res.data.commessa_dettaglio[0].id_temp = "";
            this.handleClick(res.data.commessa_dettaglio[0]);
          })
          .catch((err) => {
            this.overlay = false;
            console.error(err);
            this.$refs.SnackbarQV.print(
              "error",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          });
      }
      this.dialogfasestandard1 = false;
    },
    // in order to add or remove to fase lavorazione list
    aggiornaFase() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "FASE",
          filter: "validita = 1",
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        this.fase_list = res.data;
        this.fase_list.map((el) => {
          this.fase_lavorazione_list.push(el.des);
        });
      });
    },
    // in  order to del on fasi
    delcommessa(item) {
      /* Controllo che su questo WO non stia lavorando nessun utente. Se
       * qualcuno ci sta lavorando stampo una snackbar di avviso e non
       * faccio nulla, altrimenti cancellerei una fase in lavorazione,
       * disordinando i dati delle chiamate dell'avanzamento e dei tempi. */
      if (item.bloccato == 1) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Il WO non può essere eliminato perché attualmente in lavorazione attiva da parte di ${item.utente_attivo}.`
        );
        return;
      }

      let deletedCicolo = [];
      item.validita = 0;
      deletedCicolo.push(item);
      const i = this.cicloLista.findIndex((it) => it.id_temp === item.id_temp);
      this.cicloLista.splice(i, 1);
      this.$emit("deletedCiclo", deletedCicolo);
    },

    // in order to clear ciclo dialog
    opendialogciclo() {
      this.Macchinadata = [];
      this.Fornitoridata = [];
      this.id_temp = "";
      this.id_um_tempo = "";
      this.id_um_pezzo = "";
      this.lead_time = null;
      this.um_tempo = "";
      this.um_pezzo = "";
      this.cod_fase = "";
      this.percentuale_parallelismo = 0;
      this.pezzi_setup = 0;
      this.pezzi_parallelismo = 0;
      this.codice = "";
      this.des1 = "";
      this.materia_prima = 0;
      this.tempo_standard = "";
      this.peso = "";
      this.des = "";
      this.fase_esterna = 0;
      this.flag_segnalazione = 0;
      this.multioperatore = 0;
      this.id_commessa_dettaglio = -1;
      this.dialogCiclo = true;
      this.note = "";
      this.singleitem = {};
      this.commessa_dettaglio_fornitori = [];
      this.commessa_dettaglio_macchina = [];
      this.commessa_dettaglio_personale = [];
    },
    // clear form when close unsaved form with cancel button
    closeDialog() {
      this.dialogCiclo = false;
      this.articolo_ciclo_fasi_macchina = [];
      this.codice = "";
      this.des1 = "";
      this.materia_prima = "";
      this.tempo_standard = "";
      this.des = "";
      this.fase_esterna = 0;
    },
    getPulsantiQuestionari() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getpulsantiheader",
          token: localStorage.user_token,
          id_profilo: "",
          tipo_oggetto: "B",
          nome_modulo: "AVANZAMENTO",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            // Resetto l'array dei pulsanti.
            this.items_pulsanti_questionari = new Array();
            const arr_tmp = new Array();
            // Popolo l'array dei pulsanti.
            res.data.forEach((e) => {
              if (e.tipo_oggetto === "B") {
                arr_tmp.push({
                  id_header: e.id_header,
                  value: e.fields,
                  text: "(B) " + e.text,
                });
              } else if (e.tipo_oggetto === "E") {
                arr_tmp.push({
                  id_header: e.id_header,
                  value: e.fields,
                  text: "(E) " + e.text,
                });
              }
            });

            arr_tmp.sort(function (a, b) {
              return ("" + a.text).localeCompare(b.text);
            });
            this.items_pulsanti_questionari = JSON.parse(
              JSON.stringify(arr_tmp)
            );
          } else {
            this.$rfs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$rfs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
    // setting vale to fasi dailog at edit
    handleClick(value) {
      /* Controllo che su questo WO non stia lavorando nessun utente. Se
       * qualcuno ci sta lavorando stampo una snackbar di avviso e non
       * faccio nulla, altrimenti potrebbero venire salvati a BE dei dati che
       * risultrebbero critici per le chiamate dell'avanzamento e dei tempi. */
      if (value.bloccato == 1) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Il WO non può essere modificato perché attualmente in lavorazione attiva da parte di ${value.utente_attivo}.`
        );
        return;
      }

      this.singleitem = value;
      this.cod_fase = this.singleitem.cod_fase;
      this.percentuale_parallelismo = this.singleitem.percentuale_parallelismo;
      this.pezzi_setup = this.singleitem.pezzi_setup;
      this.pezzi_parallelismo = this.singleitem.pezzi_parallelismo;
      this.des1 = this.singleitem.des1;
      this.des = this.singleitem.des;
      this.data_scadenza = this.singleitem.data_scadenza
        ? this.singleitem.data_scadenza
        : "";
      this.ora_inizio_pianificata = this.singleitem.ora_inizio_pianificata
        ? this.singleitem.ora_inizio_pianificata
        : "";
      this.materia_prima = this.singleitem.materia_prima;
      if (this.materia_prima == "1") {
        this.materia_prima = 1;
      }
      if (this.materia_prima == "0") {
        this.materia_prima = 0;
      }
      this.tempo_standard = this.singleitem.tempo_standard;
      this.peso = this.singleitem.peso;
      this.fase_esterna = this.singleitem.fase_esterna;
      if (this.fase_esterna == "1") {
        this.fase_esterna = 1;
      }
      if (this.fase_esterna == "0") {
        this.fase_esterna = 0;
      }
      this.flag_segnalazione = this.singleitem.flag_segnalazione == 1 ? 1 : 0;
      this.multioperatore = this.singleitem.multioperatore == 1 ? 1 : 0;
      this.id_commessa_dettaglio = this.singleitem.id_commessa_dettaglio
        ? this.singleitem.id_commessa_dettaglio
        : -1;
      this.note = this.singleitem.note;
      this.id_temp = this.singleitem.id_temp;
      this.lead_time = this.singleitem.lead_time;
      this.um_tempo = this.singleitem.um_tempo;
      this.um_pezzo = this.singleitem.um_pezzo;
      this.Fornitoridata = JSON.parse(
        JSON.stringify(value.commessa_dettaglio_fornitori)
      );
      this.Macchinadata = JSON.parse(
        JSON.stringify(value.commessa_dettaglio_macchina)
      );
      this.commessa_dettaglio_fornitori = value.commessa_dettaglio_fornitori;
      this.commessa_dettaglio_fornitori.map((it) => {
        if (it.predefinito == "0") {
          it.predefinito = 0;
        }
        if (it.predefinito == "1") {
          it.predefinito = 1;
        }
      });
      this.commessa_dettaglio_macchina = value.commessa_dettaglio_macchina;
      this.commessa_dettaglio_macchina.map((it) => {
        if (it.predefinito == "0") {
          it.predefinito = 0;
        }
        if (it.predefinito == "1") {
          it.predefinito = 1;
        }
      });
      this.commessa_dettaglio_personale = value.commessa_dettaglio_personale;
      this.dialogCiclo = true;
    },
    // check if cod fase is duplicated
    checkcodfase(item) {
      this.cicloLista &&
        this.cicloLista.map((it) => {
          if (it.cod_fase == item.cod_fase && it.id_ciclo_fasi == -1) {
            this.snackbar = true;
            this.snackbar_color = "error";
            this.snackbar_icon = "mdi-window-close";
            this.snackbar_text =
              "Non è possibile salvare due cicli con lo stesso codice fase";
            return;
          }
          if (it.cod_fase == item.cod_fase && item.id_temp != it.id_temp) {
            this.snackbar = true;
            this.snackbar_color = "error";
            this.snackbar_icon = "mdi-window-close";
            this.snackbar_text =
              "Non è possibile salvare due cicli con lo stesso codice fase";
            return;
          }
        });
    },
    clickPrelieviCommessa(item) {
      /*if (this.cicloData.commessa[0].id_stato != this.id_stato_creata) {
        this.$refs.SnackbarQV.print(
          "orange",
          "I componenti possono essere impegnati solo quando la commessa è in stato creato."
        );
        return;
      }*/

      // Mi metto da parte i dati per i prelievi.
      this.work_order_sel = item;

      // Se la commessa gestisce già la materia prima, apro il dialog.
      if (this.flag_picking === 1) {
        this.prelievi_visible = true;
      } else {
        // Se la commessa non gestisce ancora gli impegni, chiedo conferma.
        this.conferma_impegno_materia = true;
      }
    },
    prelieviCommessa() {
      // Registro che la commessa gestisce la materia prima.
      this.flag_picking = 1;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setprelievocommessa",
          token: localStorage.user_token,
          id_commessa: this.cicloData.commessa[0].id_commessa,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.conferma_impegno_materia = false;
            this.prelievi_visible = true;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile registrare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile registrare i dati."
          );
        });
    },
    salvaOperazioniFase(arg) {
      this.dialog_operazioni = false;

      const singleItem_tmp = JSON.parse(JSON.stringify(this.singleItem));

      singleItem_tmp.operazioni = arg.filter(
        (o) =>
          o.id_commessa_operazione > 0 ||
          o.seleziona_suggerimento == 1 ||
          o.seleziona_suggerimento == 0 ||
          (o.seleziona_suggerimento === undefined && o.validita == 1) ||
          (o.id_commessa_operazione > 0 && o.validita == 0)
      );

      this.cicloLista.forEach((e, index) => {
        if (e.id_temp == this.singleItem.id_temp) {
          this.$set(this.cicloLista, index, singleItem_tmp);
        }
      });
    },
    salvaQuestionariAssociati() {
      // Controllo che gli eventi siano ok.
      let chk_btn = true;

      this.items_questionari_associati
        .filter((e) => e.validita == 1)
        .forEach((f1) => {
          if (f1.pulsante == null || f1.pulsante == "") {
            chk_btn = false;
          }
        });

      if (chk_btn === false) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Tutti i questionari devono essere associati ai pulsanti."
        );
        return;
      }

      // Aggiorno i questionari della fase selezionata.
      this.cicloLista.forEach((f) => {
        if (f.id_fase == this.id_fase_sel) {
          f.t_moduli_relazioni = new Array();
          f.t_moduli_relazioni = Array.from(this.items_questionari_associati);
        }
      });

      // Chiudo la finestra di dialogo dei questionari associati alla fase.
      this.questionari_fase_visible = false;
    },
    switchFlagMultioperatore() {
      const val_tmp =
        this.multioperatore == null ||
        this.multioperatore == "" ||
        this.multioperatore == 0
          ? 1
          : 0;
      this.multioperatore = val_tmp;
    },
    switchFlagSegnalazione() {
      const val_tmp =
        this.flag_segnalazione == null ||
        this.flag_segnalazione == "" ||
        this.flag_segnalazione == 0
          ? 1
          : 0;
      this.flag_segnalazione = val_tmp;
    },
    switchMultiplo(arg) {
      // Mi faccio un oggetto con il valore di selezione corretto.
      const obj_tmp = Object.assign({}, arg);
      obj_tmp.multiplo = arg.multiplo == 0 ? 1 : 0;

      // Mi metto da parte l'indice selezionato.
      let index = -1;
      for (let i = 0; i < this.items_questionari_associati.length; i++) {
        if (
          this.items_questionari_associati[i].id_relazione == arg.id_relazione
        ) {
          index = i;
        }
      }

      this.$set(this.items_questionari_associati, index, obj_tmp);
    },
    switchObblogatorieta(arg) {
      // Mi faccio un oggetto con il valore di selezione corretto.
      const obj_tmp = Object.assign({}, arg);
      obj_tmp.obbligatorio = arg.obbligatorio == 0 ? 1 : 0;

      // Mi metto da parte l'indice selezionato.
      let index = -1;
      for (let i = 0; i < this.items_questionari_associati.length; i++) {
        if (
          this.items_questionari_associati[i].id_relazione == arg.id_relazione
        ) {
          index = i;
        }
      }

      this.$set(this.items_questionari_associati, index, obj_tmp);
    },
    // in order to save or update fasi
    updateCicloFasi() {
      // Controllo che il Tipo Produzione e la Fase Lavorazione
      if (
        this.des1 == "" ||
        this.des1 == null ||
        this.des == "" ||
        this.des == null
      ) {
        this.snackbar = true;
        this.snackbar_background = "orange";
        this.snackbar_icon = "mdi-alert";
        this.snackbar_icon_color = "white";
        this.snackbar_text =
          "Definire almeno il Tipo Produzione e la Fase Lavorazione prima di salvare.";
        this.snackbar_text_color = "white";
        return;
      }

      // Controllo che id_temp non sia valorizzato
      if (!this.singleitem.id_temp) {
        if (this.cod_fase == "") {
          this.snackbar = true;
          this.snackbar_background = "orange";
          this.snackbar_icon = "mdi-alert";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Inserire il Cod. Fase prima di salvare.";
          this.snackbar_text_color = "white";
          return;
        }
        // Se il controllo viene superato, procedo al salvataggio
        let data = {};
        data.id_commessa_dettaglio = -1;
        data.id_commessa = this.cicloData.commessa.id_commessa
          ? this.cicloData.commessa.id_commessa
          : -1;
        data.data_pianificata = null;
        data.id_articolo = this.IdArticolo;
        this.produzione_list.map((prod) => {
          if (prod.des === this.des1) {
            data.id_tipo_fase = prod.id_tabella;
          }
        });
        data.materia_prima = this.materia_prima;
        data.fase_esterna = this.fase_esterna;
        data.cod_fase = this.cod_fase;
        data.id_ciclo_autocontrollo = this.singleitem.id_ciclo_autocontrollo;
        data.percentuale_parallelismo = this.percentuale_parallelismo;
        data.pezzi_setup = this.pezzi_setup;
        data.pezzi_parallelismo = this.pezzi_parallelismo;
        this.fase_list.map((el) => {
          if (el.des === this.des) {
            data.id_fase = el.id_tabella;
          }
        });
        this.unita_misura_peso.map((it) => {
          if (it.des == this.um_pezzo) {
            data.id_um_pezzo = it.id_tabella;
            data.um_pezzo = it.des;
          }
        });
        this.unita_misura_lead_time.map((mi) => {
          if (mi.des == this.um_tempo) {
            data.id_um_tempo = mi.id_tabella;
            data.um_tempo = mi.des;
          }
        });
        data.peso = this.peso;
        data.flag_segnalazione = this.flag_segnalazione;
        data.multioperatore = this.multioperatore;
        data.lotto_produzione = null;
        data.id_macchina = null;
        data.file_inviato_macchina = null;
        data.id_attrezzatura = null;
        data.id_anagrafica = null;
        data.tempo_standard = this.tempo_standard;
        data.lead_time = this.lead_time;
        data.lotto_lavorazione = null;
        data.costo_lavorazione = null;
        data.pezzi_ora_min = null;
        data.pezzi_ora_max = null;
        data.tempo_setup = null;
        data.data_scadenza = this.data_scadenza
          ? moment(this.data_scadenza).format("DD/MM/YYYY")
          : "";
        data.ora_inizio_pianificata = this.ora_inizio_pianificata;

        data.note = this.note;
        data.riga_fase = null;
        data.riga = null;
        data.validita = 1;
        data.id_temp = moment().unix();
        data.des = this.des;
        data.des1 = this.des1;
        data.um_pezzo = this.um_pezzo;
        data.um_tempo = this.um_tempo;
        this.checkcodfase(data);
        if (!this.fase_esterna) {
          var macchinawithpref = [];
          this.commessa_dettaglio_macchina.map((it) => {
            if (it.predefinito == 1 && it.validita == 1) {
              macchinawithpref.push(it);
            }
          });

          /* Controllo su fasi interne di non produzione disabilitato
           * il 21/09/2023 su richiesta di ALberto per Ferrara Quarzi. */
          if (
            macchinawithpref.length < 1 /*&&
            this.produzione_list.filter((e) => e.des == this.des1)[0].cod ===
              "P"*/
          ) {
            this.snackbar = true;
            this.snackbar_background = "orange";
            this.snackbar_icon = "mdi-alert";
            this.snackbar_icon_color = "white";
            this.snackbar_text =
              "Le fasi interne devono essere associate a una macchina predefinita.";
            this.snackbar_text_color = "white";
            return;
          }
          data.id_macchina = macchinawithpref[0].id_macchina;
          this.commessa_dettaglio_fornitori.map((it) => (it.predefinito = 0));
        }
        if (this.fase_esterna) {
          var fornitoriwithpref = [];
          this.commessa_dettaglio_fornitori.map((it) => {
            if (it.predefinito == 1) {
              fornitoriwithpref.push(it);
            }
          });
          if (fornitoriwithpref.length < 1) {
            this.snackbar = true;
            this.snackbar_background = "orange";
            this.snackbar_icon = "mdi-alert";
            this.snackbar_icon_color = "white";
            this.snackbar_text =
              "È necessario selezionare una Fornitura predefinita.";
            this.snackbar_text_color = "white";
            return;
          }
          this.commessa_dettaglio_macchina.map((it) => (it.predefinito = 0));
        }
        data.commessa_dettaglio_personale = this.commessa_dettaglio_personale;
        data.commessa_dettaglio_macchina = this.commessa_dettaglio_macchina;
        data.commessa_dettaglio_fornitori = this.commessa_dettaglio_fornitori;
        data.operazioni = this.singleitem.operazioni
          ? this.singleitem.operazioni
          : new Array();
        this.dialog = false;
        if (this.snackbar) {
          return;
        }
        if (!this.snackbar) {
          this.cicloLista.push(data);
          this.dialogCiclo = false;
          this.cicloLista.sort(
            (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
          );
          this.cicloData.commessa_dettaglio = this.cicloLista;
        }
      }
      if (this.singleitem.id_temp) {
        if (this.cod_fase == "") {
          this.snackbar = true;
          this.snackbar_background = "orange";
          this.snackbar_icon = "mdi-alert";
          this.snackbar_icon_color = "white";
          this.snackbar_text = "Inserire il Cod. Fase prima di salvare.";
          this.snackbar_text_color = "white";
          return;
        }
        let data = {};
        data.id_commessa_dettaglio = this.singleitem.id_commessa_dettaglio;
        data.id_commessa = this.singleitem.id_commessa;
        data.data_pianificata = null;
        data.id_articolo = this.IdArticolo;
        this.produzione_list.map((prod) => {
          if (prod.des === this.des1) {
            data.id_tipo_fase = prod.id_tabella;
          }
        });
        data.materia_prima = this.materia_prima;
        data.fase_esterna = this.fase_esterna;
        data.cod_fase = this.cod_fase;
        data.id_ciclo_autocontrollo = this.singleitem.id_ciclo_autocontrollo;
        data.percentuale_parallelismo = this.percentuale_parallelismo;
        data.pezzi_setup = this.pezzi_setup;
        data.pezzi_parallelismo = this.pezzi_parallelismo;
        this.fase_list.map((el) => {
          if (el.des === this.des) {
            data.id_fase = el.id_tabella;
            return data;
          }
        });
        data.peso = this.peso;
        data.flag_segnalazione = this.flag_segnalazione;
        data.multioperatore = this.multioperatore;
        data.lotto_produzione = null;
        data.id_macchina = null;
        data.file_inviato_macchina = null;
        data.id_attrezzatura = null;
        data.id_anagrafica = null;
        data.tempo_standard = this.tempo_standard;
        data.lead_time = this.lead_time;
        data.lotto_lavorazione = null;
        data.costo_lavorazione = null;
        data.data_scadenza = this.data_scadenza
          ? moment(this.data_scadenza, ["YYYY-MM-DD"]).format("DD/MM/YYYY")
          : "";
        data.ora_inizio_pianificata = this.ora_inizio_pianificata;
        data.pezzi_ora_max = null;
        data.pezzi_ora_min = null;
        data.tempo_setup = null;
        if (!this.um_pezzo) {
          data.id_um_pezzo = null;
        }
        this.unita_misura_peso.map((it) => {
          if (it.des === this.um_pezzo) {
            data.id_um_pezzo = it.id_tabella;
          }
        });
        if (!this.um_tempo) {
          data.id_um_tempo = null;
        }
        this.unita_misura_lead_time.map((mi) => {
          if (mi.des === this.um_tempo) {
            data.id_um_tempo = mi.id_tabella;
          }
        });
        data.note = this.note;
        data.riga_fase = null;
        data.riga = null;
        data.validita = 1;
        data.id_temp = this.singleitem.id_temp;
        // data.id_temp_dettaglio = moment.unix();
        data.des = this.des;
        data.des1 = this.des1;
        data.um_pezzo = this.um_pezzo;
        data.um_tempo = this.um_tempo;
        this.checkcodfase(data);
        if (this.deletedMacchina.length > 0) {
          this.$emit("delMacchina", this.deletedMacchina);
        }
        if (this.deletedPersonale.length > 0) {
          this.$emit("delPersonale", this.deletedPersonale);
        }
        if (this.deletedFornitura.length > 0) {
          this.$emit("delFornitura", this.deletedFornitura);
        }
        if (!this.fase_esterna) {
          let macchinawithpref = [];
          this.commessa_dettaglio_macchina.map((it) => {
            if (it.predefinito === 1 && it.validita == 1) {
              macchinawithpref.push(it);
            }
          });

          /* Controllo su fasi interne di non produzione disabilitato
           * il 21/09/2023 su richiesta di ALberto per Ferrara Quarzi. */
          if (
            macchinawithpref.length < 1 /*&&
            this.produzione_list.filter((e) => e.des == this.des1)[0].cod ===
              "P"*/
          ) {
            this.snackbar = true;
            this.snackbar_background = "orange";
            this.snackbar_icon = "mdi-alert";
            this.snackbar_icon_color = "white";
            this.snackbar_text =
              "Le fasi interne devono essere associate a una macchina predefinita.";
            this.snackbar_text_color = "white";
            return;
          }
          data.id_macchina = macchinawithpref[0].id_macchina;
          this.commessa_dettaglio_fornitori.map((it) => (it.predefinito = 0));
        }
        if (this.fase_esterna) {
          let fornitoriwithpref = [];
          this.commessa_dettaglio_fornitori.map((it) => {
            if (it.predefinito === 1) {
              fornitoriwithpref.push(it);
            }
          });
          if (fornitoriwithpref.length < 1) {
            this.snackbar = true;
            this.snackbar_background = "orange";
            this.snackbar_icon = "mdi-alert";
            this.snackbar_icon_color = "white";
            this.snackbar_text =
              "È necessario selezionare una fornitura predefinita.";
            this.snackbar_text_color = "white";
            return;
          }
          this.commessa_dettaglio_macchina.map((it) => (it.predefinito = 0));
        }
        data.commessa_dettaglio_personale =
          this.commessa_dettaglio_personale.length === 0
            ? []
            : this.commessa_dettaglio_personale;
        data.commessa_dettaglio_macchina = this.commessa_dettaglio_macchina;
        data.commessa_dettaglio_fornitori = this.commessa_dettaglio_fornitori;
        data.operazioni = this.singleitem.operazioni
          ? this.singleitem.operazioni
          : new Array();
        if (!this.snackbar) {
          let i = this.cicloLista.findIndex(
            (it) => it.id_temp === data.id_temp
          );
          this.cicloLista.splice(i, 1, data);
          this.cicloLista.sort(
            (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
          );
          this.cicloData.commessa_dettaglio = this.cicloLista;
        }
        this.dialog = false;
        this.dialogCiclo = false;
      }
    },
  },
  computed: {
    computed_nuove_fasi_presenti() {
      return this.cicloLista.findIndex((e) => e.id_commessa_dettaglio == -1) !=
        -1
        ? true
        : false;
    },
    formatdataScadenza() {
      return this.data_scadenza
        ? moment(this.data_scadenza, ["YYYY-MM-DD", "YYYY-MM-DD"]).format(
            "DD/MM/YYYY"
          )
        : "";
    },
  },
  mounted() {
    this.getHeaderCommessaDettaglio();
    this.getPulsantiQuestionari();

    // Geeting all autocomplete list values
    let request = {
      controller: "Magazzino",
      method: "POST",
      richiesta: {
        action: "gettabelle",
        token: localStorage.getItem("user_token"),
        tipo: "'UNITA_MISURA','TIPO_PRODUZIONE','FASE','COMMESSA_STATO','EVENTI_QUESTIONARI','OPERAZIONE_FASE_COMMESSA'",
        filter: "validita = 1",
      },
    };
    this.$store.dispatch("api", request).then((res) => {
      // Gestisco l'array che ricevo dal BE per il tipo produzione
      this.produzione_list = res.data.TIPO_PRODUZIONE
        ? res.data.TIPO_PRODUZIONE
        : new Array();

      // Gestisco l'array che ricevo dal BE per la fase
      this.fase_list = res.data.FASE;
      this.fase_list.map((el) => {
        this.fase_lavorazione_list.push(el.des);
      });
      // Gestisco l'array che ricevo dal BE per le unità di misura
      this.unita_misura_mod_list = res.data.UNITA_MISURA;
      this.unita_misura_mod_list.map((it) => {
        if (it.val_txt === "H") {
          this.unita_misura_lead_time.push(it);
        }
      });
      res.data.UNITA_MISURA.map((el) => {
        if (el.val_txt === "P") {
          this.unita_misura_peso.push(el);
        }
      });

      if (res.data.COMMESSA_STATO) {
        res.data.COMMESSA_STATO.forEach((e) => {
          switch (e.val_int) {
            case -1:
              this.id_stato_annullata = e.id_tabella;
              break;
            case 0:
              this.id_stato_creata = e.id_tabella;
              break;
            case 1:
              this.id_stato_aperta = e.id_tabella;
              break;
            case 2:
              this.id_stato_chiusa = e.id_tabella;
              break;
            case 3:
              this.id_stato_sospesa = e.id_tabella;
              break;
            default:
              break;
          }
        });
      }
    });
    if (this.cicloData.commessa.length > 0) {
      this.flag_picking = this.cicloData.commessa[0].flag_picking;
    }
    this.cicloLista = this.cicloData.commessa_dettaglio;
    this.cicloLista &&
      this.cicloLista.map((it) => (it.data_pianificata = null));
    this.cicloLista &&
      this.cicloLista.sort(
        (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
      );
  },
};
</script>
<style lang="scss">
.artDialog {
  overflow-x: hidden;
  -webkit-box-shadow: none !important;
  -moz-box-shadow: none !important;
  box-shadow: none !important;
}
</style>
